import React, {useState, useEffect, useContext} from 'react';
import { Link } from 'react-router-dom';
import { BsTwitter, BsFacebook, BsYoutube, BsLinkedin, BsWhatsapp } from "react-icons/bs";
import Button from './Button';
import { ModalContext } from '../context/ModalContext';
import axios from 'axios';

const SocialLinks = () => {
    const [socialMediaData, setSocialMediaData] = useState(null);
    useEffect(() => {
        const fetchSocialDetails = async () => {
            try {
                const res = await axios.get('/api/fetchsocialmedia', {
                    headers: {
                        Authorization: `${localStorage.getItem("token")}`, // if using JWT
                    }
                });
                if (res.data && res.data.length > 0) {
                    setSocialMediaData(res.data[0]);
                }
            } catch (err) {
                console.error("Failed to fetch contact data:", err);
            }
        };

        fetchSocialDetails();
    }, []);
    const modalContext = useContext(ModalContext);

    return (
        <>
        <div className='social-link flex flex-col fixed right-0 top-1/3 z-40 text-xl items-end space-y-1'>
            <div className='sm:flex flex-col space-y-1 items-center bg-slate-950 text-white bg-opacity-90 rounded-tl-md rounded-bl-md shadow-lg hidden overflow-hidden'>
                <Link to={socialMediaData?.twitter || "#"} target='_blank' className='hover:bg-orange-500 hover:text-white transition-all duration-300'><BsTwitter className='mx-2 my-2' /></Link>
                <Link to={socialMediaData?.facebook || "#"} target='_blank' className='hover:bg-orange-500 hover:text-white transition-all duration-300'><BsFacebook className='mx-2 my-2' /></Link>
                <Link to={socialMediaData?.youtube || "#"} target='_blank' className='hover:bg-orange-500 hover:text-white transition-all duration-300'><BsYoutube className='mx-2 my-2' /></Link>
                <Link to={socialMediaData?.linkedin || "#"} target='_blank' className='hover:bg-orange-500 hover:text-white transition-all duration-300'><BsLinkedin className='mx-2 my-2' /></Link>
            </div>
            
            <Button type='button' variant='primary' className='font-normal px-4 py-1 text-lg rounded-tl-md rounded-tr-md hover:bg-sky-950 hover:border-transparent hover:text-white transform -rotate-90 origin-bottom-right shadow-lg shadow-slate-900 uppercase'  onClick={() => {
                modalContext.setShowEnquiryPopup(true);
            }}>Enquiry</Button>
            
        </div>
        </>
    );
}

export default SocialLinks;